import { AgencyIcon } from "../helpers/AgencyIcon";

export const HeaderNormal = ({ data, editAgency, deleteAgency, toggleFields }) => {

  const viewAgencyButton = <button
    className="tgbl-button tgbl-button--theme-warning tgbl-button--size-sm" type="button"
    aria-label="View" role="tooltip" data-tgbl-microtip-position="top"
    onClick={() => window.open(data.link, '_blank').focus() }
  >
    <span className="tgbl-visually-hidden">Learn more</span>
    <AgencyIcon type={'view'}/>
  </button>

  const editAgencyButton = <button
    className="tgbl-button tgbl-button--theme-secondary tgbl-button--size-sm" type="button"
    aria-label="Edit" role="tooltip" data-tgbl-microtip-position="top"
    onClick={editAgency}
  >
    <span className="tgbl-visually-hidden">Edit</span>
    <AgencyIcon type={'edit'}/>
  </button>

  const deleteAgencyButton = <button
    className="tgbl-button tgbl-button--theme-destructive tgbl-button--size-sm"
    type="button" aria-label="Delete" role="tooltip" data-tgbl-microtip-position="top"
    onClick={deleteAgency}
  >
    <span className="tgbl-visually-hidden">Delete</span>
    <AgencyIcon type={'delete'}/>
  </button>

  const expandButton = <button
    className={`tgbl-button tgbl-button--theme-primary tgbl-button--style-rounded tgbl-user-accrediting-agencies__list__item__toggle ${ data.showingFields ? 'tgbl-user-accrediting-agencies__list__item__toggle--expanded' : ''}`}
    type="button"
    onClick={toggleFields}
  >
    <span className="tgbl-button__text">View</span>
    <AgencyIcon type={'expand'}/>
  </button>

  let statusClass = data.enrolmentStatus
  if ( statusClass === 'approved' && data.licenseIncomplete ) statusClass = 'warning'
  if ( data.agency.value === null ) statusClass = 'custom'
  return (
    <div className="tgbl-user-accrediting-agencies__list__item__header">
      <span className={`tgbl-user-accrediting-agencies__list__item__status tgbl-user-accrediting-agencies__list__item__status--${statusClass}`}>
        <AgencyIcon type={ data.enrolmentStatus }/>
      </span>

      <div className="tgbl-user-accrediting-agencies__list__item__title">
        <span className="tgbl-user-accrediting-agencies__list__item__title__text">
          { data.agency.label }
        </span>
        { data.enrolmentStatus === 'pending' && <span className="tgbl-user-accrediting-agencies__list__item__title__status"> (Pending Approval)</span> }
      </div>

      <div className="tgbl-user-accrediting-agencies__list__item__actions">
        { data.link && viewAgencyButton }
        { data.showEditButton && editAgencyButton }
        { data.showDeleteButton && deleteAgencyButton }
      </div>

      { data.showEditButton && expandButton }
    </div>
  )
}
